export default function LaunchpadTagsPage() {
  return <section className='launchpad-tags-view card'>
    <div className='section-header'>
      <div>
        <h2>Launchpad Tags</h2>
        <p>Manage Launchpad tag definitions separately from individual pages.</p>
      </div>
    </div>

    <div className='empty-state'>
      <h3>Tag management is next up</h3>
      <p>This tab is in place so we can add Launchpad Tag CRUD here without mixing it into the page editor.</p>
    </div>
  </section>
}
